<script setup lang="ts">
import type HotelPackage from '@itinerary/hotel/HotelPackage';
import HotelCardSection from '@components/ui/hotel&view/card-section/sections/HotelCardSection.vue';

defineProps<{
    showHotelsOnMap?: boolean;
}>();

const emit = defineEmits<{
    closeMap: [];
    openFilters: [];
    view: [];
}>();

const itineraryStore = useItineraryStore();
const { reservableList } = storeToRefs(itineraryStore);
const contentStore = useContentStore();
const { hotelCityBanner } = classToRefs(contentStore);
const landingBackground = computed(
    () => `url"(${hotelCityBanner.value?.backgroundImage || ''})"`
);
const hotelModule = useHotelModule();
const { hasNextPage } = moduleToRefs(hotelModule);
</script>
<template>
    <div class="landing-view-root">
        <div v-if="hotelCityBanner" class="city-banner-container">
            <div class="center-content">
                <img :src="hotelCityBanner.cityNotation" alt="notation" />
                <mr-typography size="display4" weight="700">
                    {{ hotelCityBanner.persianName }}
                </mr-typography>
            </div>
        </div>
        <div class="cards-container">
            <HotelCardSection
                key="hotel-reservable-list"
                class="cards-container"
                display-banners
                force-mobile-view
                preload-first-image
                :list="reservableList as HotelPackage[]"
                :map-hotel-list="reservableList as HotelPackage[]"
                :show-map="showHotelsOnMap"
                :load-infinite="{ hasNext: hasNextPage }"
                @load-more="hotelModule.loadMore()"
                @view-section="emit('view')"
                @close-map="emit('closeMap')"
                @open-filters="emit('openFilters')"
            />
        </div>
    </div>
</template>
<style scoped lang="scss">
.landing-view-root {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    .city-banner-container {
        width: 100%;
        height: 260px;
        background-image: v-bind(landingBackground);
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        .center-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;
        }
    }
    .landing {
        width: 100%;
        opacity: 0.25;
        border-radius: 12px;
    }
    .cards-container {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        @include mobile-only {
            flex-wrap: nowrap;
            flex-direction: column;
        }
    }
}
</style>
